module.exports = __webpack_public_path__ + "static/biko-ube-50dbaf09c1bd98d67266264f6a64d965.jpg";